import { render, staticRenderFns } from "./MerchantDetail.vue?vue&type=template&id=a820b538&scoped=true&"
import script from "./MerchantDetail.vue?vue&type=script&lang=js&"
export * from "./MerchantDetail.vue?vue&type=script&lang=js&"
import style0 from "./MerchantDetail.vue?vue&type=style&index=0&id=a820b538&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a820b538",
  null
  
)

export default component.exports